import { NextLink } from '@/atoms';
import { Pill } from '@/molecules';

type TypeListOfCategories = {
  categories?: Array<{
    name: string;
    uri: string;
  }>;
  categoriesFeatured?: Array<{
    name: string;
    uri: string;
  }>;
  theme: 'default' | 'brand' | 'custom';
  pillsBackgroundColor?: string;
  pillsTextColor: 'white' | 'black';
  listOfCategoriesBackgroundColor?: string;
};

/**
 * ListOfCategories
 */
export const ListOfCategories = ({
  bloque,
  id,
  className,
}: {
  bloque: TypeListOfCategories;
  id: string;
  className?: string;
}) => (
  <section
    id={id}
    className={`overflow-x-auto px-4 pb-4 pt-2 md:py-8 ${className ?? ''}`}
    {...(bloque.listOfCategoriesBackgroundColor && {
      style: { backgroundColor: bloque.listOfCategoriesBackgroundColor },
    })}
  >
    <div className="flex flex-col">
      <div className="flex min-w-max flex-row items-center justify-center gap-6 pr-4 lg:pr-0">
        {bloque.categories?.filter(Boolean).map((item, index) => (
          <NextLink
            href={item.uri.replace('categoria-producto/', '')}
            key={index}
            passHref
          >
            <Pill
              as="a"
              {...(bloque.theme === 'default' && {
                theme: 'primary',
                textColor: 'black',
              })}
              {...(bloque.theme === 'brand' && {
                theme: 'brand',
                textColor: bloque.pillsTextColor,
              })}
              {...(bloque.theme === 'custom' && {
                theme: 'custom',
                textColor: bloque.pillsTextColor,
                style: { backgroundColor: bloque.pillsBackgroundColor },
              })}
              aria-label={item.name}
            >
              {item.name}
            </Pill>
          </NextLink>
        ))}

        {bloque.theme === 'default' &&
          bloque.categories &&
          bloque.categoriesFeatured && (
            <span className="h-6 w-px bg-primary-200" />
          )}

        {bloque.categoriesFeatured?.filter(Boolean).map((item, index) => (
          <NextLink
            href={item.uri.replace('categoria-producto/', '')}
            key={index}
            passHref
          >
            <Pill
              as="a"
              {...(bloque.theme === 'default' && {
                theme: 'secondary',
                textColor: 'black',
              })}
              {...(bloque.theme === 'brand' && {
                theme: 'brand',
                textColor: bloque.pillsTextColor,
              })}
              {...(bloque.theme === 'custom' && {
                theme: 'custom',
                textColor: bloque.pillsTextColor,
                style: { backgroundColor: bloque.pillsBackgroundColor },
              })}
              aria-label={item.name}
            >
              {item.name}
            </Pill>
          </NextLink>
        ))}
      </div>
    </div>
  </section>
);

export default ListOfCategories;
